import React from "react";
import Hero from "../../components/hero/hero";
import Navbar from "../../components/navbar/navbar";

const Home = () => {
  return (
    <>
      <Navbar />
      <Hero />
    </>
  );
};

export default Home;
